import StoreListItem from './StoreListItem';

export default StoreListItem;
